import React, { forwardRef, useImperativeHandle, useState } from 'react'
import {
  Container,
  NoScroll,
  SidenavContentBackdrop,
  SidenavContentContainer,
  SidenavMenuContainer,
} from './styles'

export enum SidenavModes {
  semiSide = 'semi-side',
  side = 'side',
  over = 'over',
}

type Props = {
  children: any
  ref?: any
  mode?: SidenavModes
  handleChange?: Function
  width?: string
}

export const SidenavContainer: React.FC<Props> = forwardRef(
  ({ children, handleChange, width, mode = 'over' }, ref) => {
    const sidenavIndex = 0
    const sidenavContentIndex = 1

    const [isOpened, setOpenedStatus] = useState<boolean>(false)

    const toggle = () => {
      setOpenedStatus((state) => {
        const newState = !state
        if (handleChange) handleChange(newState)
        return newState
      })
    }

    useImperativeHandle(ref, () => ({ toggle }))

    const items: any = React.Children.toArray(children)

    const isSideMode = mode === SidenavModes.side
    const isSemiSideMode = mode === SidenavModes.semiSide
    const isOverMode = mode === SidenavModes.over

    return (
      <Container data-testid="sidenav-container">
        <SidenavMenuContainer
          data-testid="sidenav-menu-container"
          isOpened={isOpened}
          width={width}
        >
          {items[sidenavIndex]}
        </SidenavMenuContainer>
        <SidenavContentContainer
          data-testid="sidenav-content-container"
          isOpened={isOpened}
          isSemiSideMode={isSemiSideMode}
          isSideMode={isSideMode}
          isOverMode={isOverMode}
        >
          {isOpened && (isOverMode || isSemiSideMode) && (
            <>
              <SidenavContentBackdrop
                data-testid="sidenav-backdrop"
                isOverMode={isOverMode}
                onClick={() => toggle()}
              />
              <NoScroll />
            </>
          )}
          {items[sidenavContentIndex]}
        </SidenavContentContainer>
      </Container>
    )
  }
)
